import api from './api';

export const getSettings = async () => {
  const { data } = await api.get('/settings');
  return data;
};

export const createSetting = async (name) => {
  const { data } = await api.post('/settings', { name });
  return data;
};

export const updateSetting = async (id, params) => {
  const { data } = await api.put(`/settings/${id}`, params);
  return data;
};

export const deleteSetting = async (id) => {
  const { data } = await api.delete(`/settings/${id}`);
  return data;
};
